import React from 'react';
import PropTypes from 'prop-types';

const InputText = ({ name, value, onChange, onBlur, onFocus, placeholder, maxLength, disabled = false, label }) => {   
    
    let id = "text_" + name + new Date().getTime() + Math.floor(Math.random() * 100);
    let handleChange = (event) => {            
        if (onChange){
            onChange(event.target.value);
        }        
    }
    let handleBlur = (event) => {                
        if (onBlur){
            onBlur(event.target.value);
        }
    }    
    let handleFocus = (event) => {                
        if (onFocus){
            onFocus(event.target.value);
        }
    }

    if (disabled){
        return (<span>{(value == null ? "" : value)}</span>)
    }

    const labelText = label ? <label htmlFor={id}>{label}</label> : "";
    return (
        <div>
            {labelText}
            <input
                id={id}
                type="text"
                name={name}
                value={(value == null ? "" : value)}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                placeholder={placeholder}
                maxLength={maxLength}
                disabled={disabled}                
            />
        </div>
      );
};

InputText.propTypes = {
  name: PropTypes.string,
  value : PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,  
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,  
  disabled: PropTypes.bool,
  label : PropTypes.string
};

// TextInput.defaultProps = {
//     useIconError: true
//   };
  


export default InputText;
